import { useUser } from "../user";
import { useBoardFirestoreSWR } from "./use-board-firestore-swr";
import { useBoardLocalSWR } from "./use-board-local-swr";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useBoardActiveSWR() {
  const { user } = useUser();
  const firestoreSWR = useBoardFirestoreSWR();
  const localSWR = useBoardLocalSWR();

  return user.authenticated ? firestoreSWR : localSWR;
}
